function shorten(text: string, max = 20) {
    if (text.length <= max) return text;
    return text.slice(0, max) + "...";
}

export { shorten };